export default __webpack_public_path__ + "static/ozzfest-8b83a4a4e0900069b71679d5bd0a9bdf.png";